import { render, staticRenderFns } from "./CreateRecruitmentTypePopup.vue?vue&type=template&id=1fc63c9a"
import script from "./CreateRecruitmentTypePopup.vue?vue&type=script&lang=js"
export * from "./CreateRecruitmentTypePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports